<h1 class="header">Content History</h1>
@if (viewMode === 'history') {
  <form [formGroup]="contentForm" class="form-container">
    <div class="row">
      <mat-form-field class="col-6">
        <mat-label>Unit</mat-label>
        <input
          type="text"
          [placeholder]="'Unit'"
          matInput
          [matAutocomplete]="autoUnit"
          formControlName="unit"
        />
        <mat-autocomplete
          #autoUnit="matAutocomplete"
          (optionSelected)="changeUnitSelection($event)"
          [displayWith]="displayFn"
        >
          @for (opt of units; track opt.value) {
            <mat-option [value]="opt">
              {{ opt.value }}: {{ opt.display }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field class="col-6">
        <mat-label>Content Type</mat-label>
        <mat-select formControlName="contentType">
          @for (type of contentTypes; track $index) {
            <mat-option [value]="type.value">
              {{ type.name }}
            </mat-option>
          }
        </mat-select>
        <mat-error>Content Type is required</mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input
            matStartDate
            placeholder="Start date"
            formControlName="startDate"
          />
          <input matEndDate placeholder="End date" formControlName="endDate" />
        </mat-date-range-input>
        <mat-hint>MM/DD/YYYY - MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>
  </form>
  <button
    mat-raised-button
    color="primary"
    class="mb-2"
    (click)="onSearchHistory()"
    [disabled]="!selectedUnit"
    ><mat-icon>search</mat-icon>Search</button
  >
  @if (currentContent) {
    <h2>Current Content</h2>
    <div><strong>Unit:</strong> {{ currentContent.unitId }}</div
    ><div><strong>Content Type:</strong> {{ currentContent.type }}</div>
    <div>
      <strong>Content:</strong>
      <pre>{{ currentContent.content }}</pre>
    </div>
  }
  @if (historyData.length) {
    <h2>Historical Content</h2>
    <kendo-grid
      [kendoGridBinding]="historyData"
      [pageable]="true"
      [pageSize]="10"
    >
      <kendo-grid-column [title]="'Actions'"
        ><ng-template kendoGridCellTemplate let-dataItem
          ><button mat-icon-button (click)="onViewContent(dataItem)"
            ><mat-icon>visibility</mat-icon></button
          ><button mat-icon-button (click)="onExportContent(dataItem)"
            ><mat-icon>file_download</mat-icon></button
          ></ng-template
        ></kendo-grid-column
      >
      @for (column of historyColConfig; track column) {
        <kendo-grid-column [field]="column.field" [title]="column.title">
          @if (column.type === 'date') {
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem[column.field] | date: 'short' }}
            </ng-template>
          }
        </kendo-grid-column>
      }
    </kendo-grid>
  }
}
@if (viewMode === 'content') {
  <button mat-button color="primary" (click)="onViewBack()"
    ><mat-icon>arrow_back</mat-icon>Back To History</button
  >
  <button mat-button color="primary" (click)="onViewCopy()"
    ><mat-icon>edit</mat-icon>Send to Editor</button
  >
  <button
    mat-button
    color="primary"
    (click)="
      onExportContent({ id: viewId, dateUpdated: viewItemInfo.dateUpdated })
    "
    ><mat-icon>file_download</mat-icon>Download</button
  >
  <app-view-content
    [viewItem]="viewItem"
    [viewItemInfo]="viewItemInfo"
  ></app-view-content>
}
